export const authConfig = {
  clientId: '403474304585-klvi6jf93pc1e3kt46ib4m8ig1a2s3g8.apps.googleusercontent.com'
};
